import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router';
import Logout from './Logout/Logout.js';
import LoginPage from './LoginPage/LoginPage.js';
import SessionTimeout from './System/SessionTimeout/SessionTimeout.js';
import SessionEnded from './System/SessoinEnded/SessionEnded.js';
import { ForgeScaffold, ForgeSkipLink } from '@tylertech/forge-react';
import OmniBarNavigation from './OmniBarNavigation/OmniBarNavigation.js';
import AccessibilityMain from './Accessibility/AccessibilityMain.js';
import getAppRoutes from './routes.js';
import PrivateRoute from './PrivateRoute/PrivateRoute.js';
import { NAVIGATION_PATHS } from '../static/navigationPaths.js';
import { useErrorPages } from './reusable/ErrorPages/errorPagesContext.js';
import GeneralErrorPage from './reusable/ErrorPages/GeneralErrorPage.js';
import { getErrorPagesByType } from './reusable/ErrorPages/errorPagesHelpers.js';
import { useNameConventions } from '../contexts/nameConventionsContext.js';
import UnauthorizedAccessPage from './reusable/ErrorPages/UnauthorizedAccessPage.js';

const AppRoutesWrapper = () => {
  const { hasPageError, getErrorPage } = useErrorPages();
  const { nameConventions } = useNameConventions();
  const getPage = (element) => {
    return hasPageError ? getErrorPage() : element;
  };

  return (
    <Routes>
      {/* Auth & System Routes */}
      <Route path={NAVIGATION_PATHS.LOGOUT} element={<Logout />} />
      <Route path={NAVIGATION_PATHS.LOGIN} element={<LoginPage />} />
      <Route path={NAVIGATION_PATHS.SESSION_TIMEOUT} element={<SessionTimeout />} />
      <Route path={NAVIGATION_PATHS.SESSION_ENDED} element={<SessionEnded />} />
      <Route
        path={NAVIGATION_PATHS.UNAUTHORISED_ACCESS}
        element={<UnauthorizedAccessPage type={getErrorPagesByType(nameConventions).PAGE_UNAUTHORIZED_ACCESS} />}
      />
      <Route path={NAVIGATION_PATHS.INVALID_URL} element={<GeneralErrorPage type={getErrorPagesByType(nameConventions).FORBIDDEN_ACCESS}/>}/>
      {/* Main App Container */}
      <Route
        path="*"
        element={
          <ForgeScaffold>
            <ForgeSkipLink slot="header" target="main-content" />
            <OmniBarNavigation />
            <AccessibilityMain>
              <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                  {getAppRoutes(nameConventions).map((route, index) => (
                    <Route
                      key={index}
                      path={route.path}
                      element={getPage(route.element)}
                    >
                      {route.children &&
                        route.children.map((child, childIdx) => (
                          <Route
                            key={childIdx}
                            path={child.path}
                            element={
                              child.protected !== false ? (
                                <PrivateRoute accessIcon={child.accessIcon}>
                                  {getPage(child.element)}
                                </PrivateRoute>
                              ) : (
                                getPage(child.element)
                              )
                            }
                          />
                        ))}
                    </Route>
                  ))}
                </Routes>
              </Suspense>
            </AccessibilityMain>
          </ForgeScaffold>
        }
      />
    </Routes>
  );
};

export default AppRoutesWrapper;
